<template>
	<div :class="['event-card', { 'active' : this.showing}]">
		<div class="event-card-content">
			<div class="col-left">
				<h3 v-if="!eventData.startTime" class="text light space-under">{{ this.today }}</h3>
				<h3 v-if="!eventData.endTime && eventData.startTime" class="text light space-under">{{ this.today }} at {{eventData.startTime}}</h3>
				<h3 v-if="eventData.endTime && eventData.startTime" class="text light space-under">{{ this.today }} at {{eventData.startTime}} - {{eventData.endTime}}</h3>
				<h4 class="text light mint">{{eventData.eventType}}</h4>
				<h2 class="text">{{eventData.eventTitle}}</h2>
				<div class="event-links">
					<h4 class="text light" v-on:click="this.hideCard">{{eventData.locationName}}</h4>
					<a v-if="eventData.eventLink" :href="eventData.eventLink" target="_blank" class="text light grey">Purchase Tickets</a>
				</div>
				<p class="text">{{ eventData.description }}</p>
			</div>
			<div class="col-right" v-if="eventData.image">
				<ImageCarousel :images="[eventData.image]"></ImageCarousel>
			</div>
		</div>
	</div>
</template>

<script>
	import ImageCarousel from '@/components/ImageCarousel.vue';
	import { DateFormat } from "@/DateFormat.js";
  
	export default {
		name: "EventCard",
		components: {
			ImageCarousel
		},
		props: {
			eventData: Object
		},
		data: function() {
			return {
				sharedStore: window.store,
				showing: false,
				today: DateFormat.now("#DDDD#, #MMMM# #D##th#")
			}
		},
		mounted: function() {
		},
		watch: {
		},
		computed: {
		},
		methods: {
			showCard: function() {
				this.sharedStore.setBackTarget("overlay");
				this.showing = true;
			},
			hideCard: function() {
				this.$emit('hideCard');
				this.showing = false;
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.event-card {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		background: rgb(25, 25, 25);
		opacity: 0;
		transform: translateY(100%);
		transition: 0.5s;
		overflow-y: auto;
		padding-bottom: 80px;
		pointer-events: none;

		&.active {
			opacity: 1;
			transform: translateY(0px);
			pointer-events: auto;
      height: 100%;
      width: 100%;
		}

		@media (min-aspect-ratio: 1/1) {
			width: 50%;
		}
	}

	.event-card-content {
		width: 100%;
		display: flex;
		flex-direction: column-reverse;
		justify-content: flex-end;
		color: #ffffff;
		text-align: left;
	}

	.col-left, .col-right {
		position: relative;
		width: 100%;
	}

	.col-left {
		padding: 20px 28px;
	}

	.col-right {
		height: 300px;
	}

  .text {
    white-space: pre-wrap;
    margin: 0;
    &.light {
      font-weight: 500;
    }
    &.mint {
      color: rgb(103, 199, 180);
    }
    &.grey {
      color: #9F9E9E;
    }
  }

  .event-links {
    display: flex;
    justify-content: space-between;
    text-decoration: underline;
    color: #9F9E9E;
    margin-bottom: 15px;
  }

	.kiosk {
		// styles for when we are in kiosk mode
		#event-card {
			height: 400px;
			background: #ffffff;
			transition: 0.5s;
		}

		.event-card-content {
			flex-direction: row;
			justify-content: flex-start;
			color: #000000;
		}

		.col-left, .col-right {
			width: 50%;
			height: 100%;
			padding: 10px;
		}
	}
</style>